<script setup lang="ts">

defineProps({
  active: {
    type: Boolean,
    default: false
  },
  forIcon: {
    type: Boolean,
    default: false
  }
})

</script>

<template>
<button :class="{
  'py-1 hover:bg-red-500 rounded': true,
  'bg-slate-700': active,
  'bg-slate-600 text-slate-300': !active,
  'px-2' : !forIcon,
  'px-1' : forIcon
}">
  <slot></slot>
</button>
</template>

<style scoped lang="scss">

</style>